import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver asked for a cash advance.
 */
export const advanceRequestV1 = tmsEventKind(
  { category: "request", kind: "advanceRequest", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      amountUsd: z.number().nullable(),
    },
  },
);

export const AdvanceRequestV1Schema = advanceRequestV1.schema;
export const AdvanceRequestV1FactsSchema = advanceRequestV1.facts;

export type AdvanceRequestV1 = z.infer<typeof AdvanceRequestV1Schema>;
export type AdvanceRequestV1Facts = z.infer<typeof AdvanceRequestV1FactsSchema>;

/**
 * Version 2: the same request, plus why the driver says they need it.
 */
export const advanceRequestV2 = tmsEventKind(
  { category: "request", kind: "advanceRequest", version: 2 },
  {
    refs: formSubmissionRefs,
    facts: {
      amountUsd: z.number().nullable(),
      /** The driver's own words for why they need the advance, trimmed; null when they left it blank. */
      reason: z.string().nullable(),
    },
  },
);

export const AdvanceRequestV2Schema = advanceRequestV2.schema;
export const AdvanceRequestV2FactsSchema = advanceRequestV2.facts;

export type AdvanceRequestV2 = z.infer<typeof AdvanceRequestV2Schema>;
export type AdvanceRequestV2Facts = z.infer<typeof AdvanceRequestV2FactsSchema>;

/** Every version of `advanceRequest`, keyed by version. What `catalog.ts` places under `request`. */
export const advanceRequest = { 1: advanceRequestV1, 2: advanceRequestV2 } as const;
